module.exports = __webpack_public_path__ + "img/jake-pfp.6009039c.png";